import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBar from "@/components/sections/NavBar";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Benefits from "@/components/sections/Benefits";
import Testimonials from "@/components/sections/Testimonials";
import About from "@/components/sections/About";
import Quote from "@/components/sections/Quote";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import MobileCallButton from "@/components/MobileCallButton";
import Admin from "@/pages/Admin";
import useReveal from "@/lib/useReveal";

function Landing() {
  useReveal();
  return (
    <>
      <NavBar />
      <main>
        <Hero />
        <Services />
        <Benefits />
        <Testimonials />
        <About />
        <Quote />
        <Contact />
      </main>
      <Footer />
      <MobileCallButton />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#0A0A0A] text-white antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111",
            border: "1px solid rgba(212,175,55,0.35)",
            color: "#F5F5F0",
          },
        }}
      />
    </div>
  );
}

export default App;
